<template>
    <CCard>
        <CCardHeader>
            <h3>Detalle Vendedor</h3>
            <h4>{{selectedSeller.nombre_Empleado}}</h4>
        </CCardHeader>
        <CCardBody>
            <CTabs>
                <CTab title="Cotizaciones">

                </CTab>
                <CTab title="Remisiones">

                </CTab>
                <CTab title="Cartera">

                </CTab>
                <CTab title="Clientes">

                </CTab>
            </CTabs>
        </CCardBody>
    </CCard>
</template>
<script>
export default {
  computed: {
    selectedSeller() {
      return this.$store.state.selectedSeller
    }
  }
}
</script>